import { FC, ReactNode } from "react";

import styles from "./FormSection.module.css";

interface Props {
  step: number;
  title: string;
  children: ReactNode;
}

export const FormSection: FC<Props> = ({ step, title, children }) => (
  <section className={styles.section}>
    <h3 className={styles.title}>
      <span className={styles.step}>{step}</span>
      {title}
    </h3>
    {children}
  </section>
);
